"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIsoDate = void 0;
const DATE_REGEX_ISO_8601 = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/;
function isIsoDate(value) {
    if (typeof value !== 'string')
        return false;
    return DATE_REGEX_ISO_8601.test(value);
}
exports.isIsoDate = isIsoDate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9kYXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0sbUJBQW1CLEdBQUcsb0ZBQW9GLENBQUE7QUFFaEgsU0FBZ0IsU0FBUyxDQUFDLEtBQWM7SUFDdEMsSUFBRyxPQUFPLEtBQUssS0FBSyxRQUFRO1FBQUUsT0FBTyxLQUFLLENBQUE7SUFDMUMsT0FBTyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7QUFDeEMsQ0FBQztBQUhELDhCQUdDIn0=